module.exports = __webpack_public_path__ + "static/media/card-Discover-mobile-inactive.faaa3c5f.svg";